import type { ProfileTaste } from '@/types/taste';
import type { TasteResponseWire } from '../schemas/taste';

/**
 * Convert the taste endpoint's wire response (snake_case) to the domain
 * {@link ProfileTaste} (camelCase). Immutable: returns a fresh object.
 */
export function mapTasteResponseWireToDomain(wire: TasteResponseWire): ProfileTaste {
  return {
    distribution: {
      notForMe: wire.distribution.not_for_me,
      okay: wire.distribution.okay,
      tryIt: wire.distribution.try_it,
      mustTry: wire.distribution.must_try,
    },
    total: wire.total,
  };
}
